import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios'
// import shopCart from "./shopCart/shopCart";
import user from "./user/user";
import address from "./user/address";
import orderList from "./order/orderList";
import socket from "./socket/socket";
import {getLocalStorWebsocketTimestemp, saveLocalStorLogin} from "../utils/localStorageCommon"
Vue.use(Vuex);
const validTime = 3 * 60 * 60 * 1000; //登录过期时间 3小时
export default new Vuex.Store({
  state: {
    websocketObj: null,
    showH: true,
    showF: true,
    shopCart: [],
    shopWHCart: [],
    account: null, //用户账号
    userInfo: {},
    userLoginTime: null, //用户登录时间
    websocketTimestemp: 0,
    eliminateKeysCategoryList: [], // 屏蔽关键词类别
    timerObj: null,
    selectOptionHbList: ["wh-self"], // 供应商搜索图书选择库存区(查询范围选择 供应商自己上传的，系统上传的)
    selectOptionCartList: ["wh-self"], // 供应商购物车选择库存区(查询范围选择 供应商自己上传的，系统上传的)
    selectOptionBookDownList: ["wh-self"], // 供应商书目下载选择库存区(查询范围选择 供应商自己上传的，系统上传的)
    onlineUsers: [],  // 在线用户
  },
  mutations: {
    // 页面刷新时防止信息丢失可以掉用本地存储获取用户信息
    initUser(state) {
      let userInfo = window.sessionStorage.getItem("userInfo");
      if (userInfo) {
        state.userInfo = JSON.parse(userInfo);
      }
      let userLoginTime = window.sessionStorage.getItem("userLoginTime");
      if (userLoginTime) {
        state.userLoginTime = JSON.parse(userLoginTime);
      }
      let shopCart = window.sessionStorage.getItem("shopCart");
      if (shopCart) {
        state.shopCart = JSON.parse(shopCart);
      }
      
      let shopWHCart = window.sessionStorage.getItem("shopWHCart");
      if (shopWHCart) {
        state.shopWHCart = JSON.parse(shopWHCart);
      }
      state.showH = true;
      state.showF = true;

      state.websocketTimestemp = getLocalStorWebsocketTimestemp(null)

      let eliminateKeysCategoryList = window.sessionStorage.getItem("eliminateKeysCategoryList");
      if (eliminateKeysCategoryList) {
        state.eliminateKeysCategoryList = JSON.parse(eliminateKeysCategoryList);
      }
    },
    // 检测有没有用户是否登录
    hasLogin(state) {
      //获取用户登录时间是否过期
      let strtime = state.userLoginTime;
      if (strtime) {
        //计算过期时间
        let vaildtime = Number(strtime) + validTime;
        let timespan = Date.parse(new Date());
        // console.log(vaildtime + "," + timespan);
        if (timespan <= vaildtime) {
          if (
            state.userInfo == null ||
            state.userInfo.userName == "" ||
            state.userInfo.userName == undefined
          ) {
            return true;
          } else {
            // 重新设置登录时间
            this.commit('set_userLoginTime')
            return false;
          }
        } else {
          state.userInfo = {};
          // 清除本地存储
          window.sessionStorage.clear();

          window.localStorage.clear();
          state.socket.warehouseLogout = 0
          this.commit('socket/opeartionWebsocketClose')
          return true;
        }
      } else {
        return true;
      }
    },
    set_selectOptionHbList(state, dataList){ // 供应商搜索图书选择库存区
      state.selectOptionHbList = dataList
    },
    set_selectOptionCartList(state, dataList){ // 供应商购物车选择库存区
      state.selectOptionCartList = dataList
    },
    set_selectOptionBookDownList(state, dataList){ // 供应商书目下载选择库存区
      state.selectOptionBookDownList = dataList
    },
    set_userLoginTime(state){
      state.userLoginTime = Date.parse(new Date());
      window.sessionStorage.setItem(
        "userLoginTime",
        Date.parse(new Date())
      );
    },
    set_eliminateKeysCategoryList(state, dataList){ // 屏蔽关键词类别
      if(dataList && dataList.length > 0){
        state.eliminateKeysCategoryList = dataList
        window.sessionStorage.setItem("eliminateKeysCategoryList", JSON.stringify(dataList));
      }
    },
  },
  actions: {
    setUserInfo({state, commit}, data){
      // console.log('22222222',state, data)
      state.userInfo = data.result.user;
      state.websocketTimestemp = data.result.websocketTimestemp;
      saveLocalStorLogin(data.result, null) // 存储 login
      window.sessionStorage.setItem("userInfo", JSON.stringify(data.result.user));
      commit('set_userLoginTime')
      commit('set_eliminateKeysCategoryList', data.result.eliminateKeysCategoryList)
    },
    setTimer({state, dispatch}){
      if(null != state.timerObj && state.timerObj){
        return false;
      }
      // 获取用户登录信息
      state.timerObj = setInterval(function(){
        dispatch('getLoginUInfo')
      }, 1000 * 60 * 5);
    },
    getLoginUInfo({state, commit, rootGetters}){
      // console.log("rootGetters['isNaName']", rootGetters['isNaName'])
      if(rootGetters['isNaName']){
        return false
      }
      axios({
        method: 'get',
        url: '/users/getLoginUserInfo',
        baseURL: Vue.prototype.baseurl+Vue.prototype.projectName+'/front',
        params: {
          uid: state.userInfo.id,
          urole: state.userInfo.role,
        },
      }).then(function (res) {
        if(res.data.success){
          // console.log('response',res)
          state.userInfo = res.data.result.user;
          commit('set_eliminateKeysCategoryList', res.data.result.eliminateKeysCategoryList)
        }
      });
    },
    // 操作 socket.js 关闭socket
    opeartion_socket_WebsocketClose({commit}){
      commit('socket/opeartionWebsocketClose');
    },
    
  },
  getters: {
    // 检测有没有用户是否登录
    isNaName: function(state, mutations) {
      //获取用户登录时间是否过期
      let strtime = state.userLoginTime;
      if (strtime) {
        //计算过期时间
        let vaildtime = Number(strtime) + validTime;
        let timespan = Date.parse(new Date());
        // console.log(vaildtime + "," + timespan);
        // console.log('state.userInfo :>> ', state.userInfo);
        if (timespan < vaildtime) {
          if (
            state.userInfo == null ||
            state.userInfo.userName == "" ||
            state.userInfo.userName == undefined
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          state.userInfo = {};
          // 清除本地存储
          window.sessionStorage.clear();
          window.localStorage.clear();
          state.socket.warehouseLogout = 0
          mutations.opeartion_socket_WebsocketClose // 关闭socket
          // this.commit('socket/opeartionWebsocketClose')
          return true;
        }
      } else {
        return true;
      }
    },
    // 验证供应商是否为会员 true是，false否
    checkWhMember:function(state) {
      var fm = false;
      var userInfo = state.userInfo
      if(userInfo && userInfo.role === 2){ // 供应商
        if(userInfo.memberStatus == 1){
          fm = true;
        }
      }
      return fm;
    },
  },
  modules: {
    // shopCart, //购物车
    user, //用户面板
    address, //地址
    orderList, //订单列表
    socket, // websocket 通讯
  },
});
